<template>
  <div class="a-ui-tab__block">
    <confirm-remove-message-dialog ref="confirmDialog" @confirm="removeMessage" @cancel="$refs.confirmDialog.close()"></confirm-remove-message-dialog>

    <div class="a-ui-tab__control-panel">
      <div class="a-ui-tab__control">
        <div class="a-ui-tab__arrow"></div>
        <div class="a-ui-tab__number-block">{{serial}}</div>
        <div class="a-ui-tab__title">
          {{message.to}}
        </div>
        <div class="a-ui-tab__text">
          {{message.subject}}
        </div>
      </div>
      <div class="a-flex-end a-align-items-center">
        <date-time class="a-input a-input--disabled text-right u-margin-right-20" :value="message.timestamp"></date-time>
        <img class="a-img-trashcan u-margin-right-20" src="@/assets/img/static/trashcan.svg" @click="onRemoveMessageClick">
      </div>
    </div>

    <div class="a-ui-tab__content-block a-ui-tab__content-block--open">
      <div class="a-ui-tab__content">
        <div class="a-ui-tab__file-flex-block">
          <div class="a-ui-tab__file-item-left">
            <div class="a-ui-tab__file-block-number">
            </div>
            <div class="a-ui-tab__text" v-html="message.body">
            </div>
          </div>
        </div>
      </div>
      <div class="a-ui-tab__content">
        <div class="a-ui-tab__file-flex-block" v-for="file in message.files">
          <div class="a-ui-tab__file-item-left">
            <div class="a-ui-tab__file-block-number">
            </div>

            <file-link :name="file.name"
                       :size="file.size"
                       :link="externalLink(file.uid)">
            </file-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ConfirmRemoveMessageDialog from '../ConfirmRemoveMessageDialog'

  export default {
    props: {
      serial: Number,
      message: Object
    },

    components: {
      ConfirmRemoveMessageDialog
    },

    methods: {
      onRemoveMessageClick() {
        this.$refs.confirmDialog.open();
      },

      async removeMessage() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('deleteMessageFromTrash', this.message);
          }
          catch(e) {
            console.error('unable to delete message from the trash', e);
            this.globalErrorHandler(e);
          }
        });

        this.$refs.confirmDialog.close();
      }
    }
  }
</script>

<style scoped>
  .a-ui-tab__file-item-left {
    max-width: initial;
  }

  .a-ui-tab__text {
    max-width: initial;
  }
</style>
